// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,import_extension=js"
// @generated from file morfi/v1/markets/backing.proto (package morfi.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { EventMetadata, Side } from "../common_pb.js";
import { file_morfi_v1_common } from "../common_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file morfi/v1/markets/backing.proto.
 */
export const file_morfi_v1_markets_backing: GenFile = /*@__PURE__*/
  fileDesc("Ch5tb3JmaS92MS9tYXJrZXRzL2JhY2tpbmcucHJvdG8SCG1vcmZpLnYxIp8CCgxCYWNraW5nRXZlbnQSJQoEbWV0YRgBIAEoCzIXLm1vcmZpLnYxLkV2ZW50TWV0YWRhdGESDgoGbWFya2V0GAIgASgMEg4KBmJhY2tlchgDIAEoDBIcCgRzaWRlGAQgASgOMg4ubW9yZmkudjEuU2lkZRIUCgxncm9zc19hbW91bnQYBSABKAQSFAoMcGxhdGZvcm1fZmVlGAYgASgEEhgKEHByaXplX3Bvb2xfZGVsdGEYByABKAMSFAoMc2hhcmVzX2RlbHRhGAggASgDEhYKDmJhY2tlcl9iYWxhbmNlGAkgASgEEhQKDGJhY2tlcl9jb3VudBgKIAEoDRIUCgxiYWNrZWRfdG90YWwYCyABKAQSCgoCdHMYDCABKAMirAEKDU1hcmtldEJhY2tpbmcSEwoLc2VxdWVuY2VfaWQYASABKAwSCgoCdHMYAiABKAQSDgoGbWFya2V0GAMgASgJEg0KBWFjdG9yGAQgASgJEhwKBHNpZGUYBSABKA4yDi5tb3JmaS52MS5TaWRlEhEKCWFtb3VudF9kNhgGIAEoBBIXCg9zaGFyZXNfZGVsdGFfZDYYByABKBISEQoJc2lnbmF0dXJlGAggASgJIroCChNUcmFkaW5nU3RhcnRlZEV2ZW50EiUKBG1ldGEYASABKAsyFy5tb3JmaS52MS5FdmVudE1ldGFkYXRhEg4KBm1hcmtldBgCIAEoDBIfChdwcml6ZV9wb29sX3RvdGFsX2JhY2tlZBgDIAEoBBIUCgxzaGFyZV9zdXBwbHkYBCABKAQSCgoCdHMYBSABKAMSIwobcG9zdF9vdXRjb21lX2NvbnZpY3Rpb25fcHBiGAcgAygNEioKInBvc3Rfb3V0Y29tZV9jb252aWN0aW9uX3RhcmdldF9wcGIYCCADKA0SMAoocG9zdF9jb252aWN0aW9uX3JldGVudGlvbl9wZXJfc2Vjb25kX3BwYhgJIAEoDRImCh5wb3N0X2xhc3RfY29udmljdGlvbl91cGRhdGVfdHMYCiABKANiBnByb3RvMw", [file_morfi_v1_common]);

/**
 * @generated from message morfi.v1.BackingEvent
 */
export type BackingEvent = Message<"morfi.v1.BackingEvent"> & {
  /**
   * @generated from field: morfi.v1.EventMetadata meta = 1;
   */
  meta?: EventMetadata | undefined;

  /**
   * @generated from field: bytes market = 2;
   */
  market: Uint8Array;

  /**
   * @generated from field: bytes backer = 3;
   */
  backer: Uint8Array;

  /**
   * @generated from field: morfi.v1.Side side = 4;
   */
  side: Side;

  /**
   * @generated from field: uint64 gross_amount = 5;
   */
  grossAmount: bigint;

  /**
   * @generated from field: uint64 platform_fee = 6;
   */
  platformFee: bigint;

  /**
   * i64 in morfi-events (signed: + on back, - on unback)
   *
   * @generated from field: int64 prize_pool_delta = 7;
   */
  prizePoolDelta: bigint;

  /**
   * i64 in morfi-events (signed)
   *
   * @generated from field: int64 shares_delta = 8;
   */
  sharesDelta: bigint;

  /**
   * @generated from field: uint64 backer_balance = 9;
   */
  backerBalance: bigint;

  /**
   * u32 in morfi-events
   *
   * @generated from field: uint32 backer_count = 10;
   */
  backerCount: number;

  /**
   * @generated from field: uint64 backed_total = 11;
   */
  backedTotal: bigint;

  /**
   * @generated from field: int64 ts = 12;
   */
  ts: bigint;
};

/**
 * Describes the message morfi.v1.BackingEvent.
 * Use `create(BackingEventSchema)` to create a new message.
 */
export const BackingEventSchema: GenMessage<BackingEvent> = /*@__PURE__*/
  messageDesc(file_morfi_v1_markets_backing, 0);

/**
 * Typed realtime payload for both market- and user-scoped backing subjects.
 * User-scoped subjects need the market in-band for activity-feed routing.
 *
 * @generated from message morfi.v1.MarketBacking
 */
export type MarketBacking = Message<"morfi.v1.MarketBacking"> & {
  /**
   * @generated from field: bytes sequence_id = 1;
   */
  sequenceId: Uint8Array;

  /**
   * @generated from field: uint64 ts = 2;
   */
  ts: bigint;

  /**
   * @generated from field: string market = 3;
   */
  market: string;

  /**
   * @generated from field: string actor = 4;
   */
  actor: string;

  /**
   * @generated from field: morfi.v1.Side side = 5;
   */
  side: Side;

  /**
   * @generated from field: uint64 amount_d6 = 6;
   */
  amountD6: bigint;

  /**
   * @generated from field: sint64 shares_delta_d6 = 7;
   */
  sharesDeltaD6: bigint;

  /**
   * @generated from field: string signature = 8;
   */
  signature: string;
};

/**
 * Describes the message morfi.v1.MarketBacking.
 * Use `create(MarketBackingSchema)` to create a new message.
 */
export const MarketBackingSchema: GenMessage<MarketBacking> = /*@__PURE__*/
  messageDesc(file_morfi_v1_markets_backing, 1);

/**
 * @generated from message morfi.v1.TradingStartedEvent
 */
export type TradingStartedEvent = Message<"morfi.v1.TradingStartedEvent"> & {
  /**
   * @generated from field: morfi.v1.EventMetadata meta = 1;
   */
  meta?: EventMetadata | undefined;

  /**
   * @generated from field: bytes market = 2;
   */
  market: Uint8Array;

  /**
   * @generated from field: uint64 prize_pool_total_backed = 3;
   */
  prizePoolTotalBacked: bigint;

  /**
   * @generated from field: uint64 share_supply = 4;
   */
  shareSupply: bigint;

  /**
   * @generated from field: int64 ts = 5;
   */
  ts: bigint;

  /**
   * exactly n_outcomes values, outcome-index ordered
   *
   * @generated from field: repeated uint32 post_outcome_conviction_ppb = 7;
   */
  postOutcomeConvictionPpb: number[];

  /**
   * exactly n_outcomes values, outcome-index ordered
   *
   * @generated from field: repeated uint32 post_outcome_conviction_target_ppb = 8;
   */
  postOutcomeConvictionTargetPpb: number[];

  /**
   * @generated from field: uint32 post_conviction_retention_per_second_ppb = 9;
   */
  postConvictionRetentionPerSecondPpb: number;

  /**
   * @generated from field: int64 post_last_conviction_update_ts = 10;
   */
  postLastConvictionUpdateTs: bigint;
};

/**
 * Describes the message morfi.v1.TradingStartedEvent.
 * Use `create(TradingStartedEventSchema)` to create a new message.
 */
export const TradingStartedEventSchema: GenMessage<TradingStartedEvent> = /*@__PURE__*/
  messageDesc(file_morfi_v1_markets_backing, 2);

